var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16169 0.127686H15.1318C16.3257 0.127686 17.2935 1.09551 17.2935 2.28938V10.9361C17.2935 12.13 16.3257 13.0978 15.1318 13.0978H4.32347L4.45545e-05 17.4213V10.9502C1.48664e-05 10.9455 0 10.9408 0 10.9361V2.28938C0 1.09551 0.967822 0.127686 2.16169 0.127686ZM18.3744 12.017V4.45111H19.4553C20.0286 4.45111 20.5784 4.67886 20.9838 5.08425C21.3892 5.48965 21.617 6.03948 21.617 6.6128V21.7446L17.2936 17.4213H6.48512C5.9118 17.4213 5.36197 17.1935 4.95657 16.7881C4.55118 16.3827 4.32343 15.8329 4.32343 15.2596V14.1787H16.2127C16.786 14.1787 17.3359 13.951 17.7413 13.5456C18.1467 13.1402 18.3744 12.5903 18.3744 12.017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.075572d936a9fb7a361ea648746ce36f.svg";
export { ForwardRef as ReactComponent };